module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-drink-e907966b44bf64a20e089e3a2041f81a.jpg";